import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { FormattedMessage } from 'react-intl';
import { signoutUser } from '../../../actions/auths';

function LogOut(props) {
  const { open, handleClose } = props;

  return (
    <Dialog
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        <FormattedMessage defaultMessage="Logout" />
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <FormattedMessage defaultMessage="Are you sure you wish to log out?" />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>
          <FormattedMessage defaultMessage="Cancel" />
        </Button>
        <Button
          variant="contained"
          onClick={props.signoutUser}
          color="primary"
          style={{
            backgroundImage: 'linear-gradient(to top, #5fdb98, #3dd985)',
            outline: 'none',
          }}
          autoFocus
        >
          <FormattedMessage defaultMessage="Logout" />
        </Button>
      </DialogActions>
    </Dialog>
  );
}

LogOut.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  signoutUser: PropTypes.func.isRequired,
};

export default connect(null, { signoutUser })(LogOut);
